export default __webpack_public_path__ + "static/media/mathematics.325b3c42.svg";